import { render, staticRenderFns } from "./CameraDialogContent.vue?vue&type=template&id=47513a08"
import script from "./CameraDialogContent.vue?vue&type=script&lang=ts"
export * from "./CameraDialogContent.vue?vue&type=script&lang=ts"
import style0 from "./CameraDialogContent.vue?vue&type=style&index=0&id=47513a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports